function About() {
  return (
    <section className="px-6 lg:px-24 py-6 lg:py-12 grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12">
      <img
        src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/about-about.png"
        alt="Zespół Drzewus - firma ogrodnicza"
        className="hidden lg:block"
      />
      <div className="flex flex-col items-start justify-center text-left gap-2">
        <h2 className="uppercase color-yellow text-xl">O nas</h2>
        <h3 className="text-3xl lg:text-5xl color-green">
          Zadbany <span className="color-yellow">ogród</span> na<br></br>
          długie lata
        </h3>
        <p className="text-gray-600 opacity-80 text-lg">
          • niwelację terenu,
          <br />
          • przygotujemy działkę pod siew trawy lub pod kątem ogrodu, <br />
          • pomożemy w koszeniu nieużytków,
          <br />
          • zadbamy o idealny stan trawników – zarówno ogrodowych, na tarasach
          zieleni, jak i murawy na boiskach sportowych,
          <br />
          • wykonamy wycinkę drzew i usuniemy samosiejki,
          <br />
          • oczyścimy przestrzeń z gałęzi i innych pozostałości roślinnych,
          <br />
          • wykonamy nawadnianie, drenaże i odwodnienia terenu,
          <br />
          • przeprowadzimy wszelkie prace ziemne,
          <br />
          • wykonamy nasadzenia,
          <br />• zaplanujemy Twój ogród od A do Zet realizując cały szereg
          różnorodnych prac dopasowanych projektu i potrzeb.
        </p>
      </div>
    </section>
  );
}

export default About;
